import { Injectable } from '@angular/core';
import { NetworkingService } from '../networking.service';
import { SharedDataService } from '../../helper/services/shared-data.service';
import { catchError, finalize, map, Observable, throwError } from 'rxjs';
import { QuizAnswer } from '../../data/models/QuizAnswer';
import { API } from '../../data/api';

@Injectable({
  providedIn: 'root'
})
export class QuizAnswerService {
  constructor(
    private networkingService: NetworkingService,
    private sharedDataService: SharedDataService
  ) {}

  getQuizAnswerList(lessonPageItemId: string): Observable<QuizAnswer[]> {
    return this.networkingService.getRequest<QuizAnswer[]>(API.quizAnswerList(lessonPageItemId))
      .pipe(
        map(response => response as QuizAnswer[]),
        catchError((error) => {
          console.error('Failed to fetch quiz answers:', error);
          return throwError(() => new Error('Failed to fetch quiz answers'));
        })
      );
  }

  getQuizAnswerDetails(quizAnswerId: string): Observable<QuizAnswer> {
    const endpoint = API.quizAnswerDetails(quizAnswerId);
    return this.networkingService.getRequest<QuizAnswer>(endpoint)
      .pipe(
        map(response => response as QuizAnswer),
        catchError((error) => {
          console.error('Failed to fetch quiz answer details:', error);
          return throwError(() => new Error('Failed to fetch quiz answer details'));
        })
      );
  }

  createQuizAnswer(quizAnswerData: {
    lessonPageItemId: string;
    answerText: string;
    responseText: string;
    isCorrect: boolean;
  }): Observable<QuizAnswer> {

    const payload = {
      lesson_page_item_id: quizAnswerData.lessonPageItemId,
      answer_text: quizAnswerData.answerText,
      response_text: quizAnswerData.responseText,
      is_correct: quizAnswerData.isCorrect,
    };

    this.sharedDataService.toggleProgressBarOn();

    return this.networkingService.postRequest(API.quizAnswerCreate, payload)
      .pipe(
        map(response => response as QuizAnswer),
        catchError((error) => {
          console.error('Failed to create quiz answer:', error);
          return throwError(() => new Error('Failed to create quiz answer'));
        }),
        finalize(() => {
          this.sharedDataService.toggleProgressBarOff();
        })
      );
  }

  alterQuizAnswer(quizAnswerId: string, quizAnswerData: {
    answerText?: string;
    responseText?: string;
  }): Observable<QuizAnswer> {

    const payload: any = {};
    if (quizAnswerData.answerText !== undefined) {
      payload.answer_text = quizAnswerData.answerText;
    }
    if (quizAnswerData.responseText !== undefined) {
      payload.response_text = quizAnswerData.responseText;
    }

    this.sharedDataService.toggleProgressBarOn();

    return this.networkingService.putRequest(API.quizAnswerAlter(quizAnswerId), payload)
      .pipe(
        map(response => response as QuizAnswer),
        catchError((error) => {
          console.error('Failed to update quiz answer:', error);
          return throwError(() => new Error('Failed to update quiz answer'));
        }),
        finalize(() => {
          this.sharedDataService.toggleProgressBarOff();
        })
      );
  }

  deleteQuizAnswer(quizAnswerId: string): Observable<void> {
    this.sharedDataService.toggleProgressBarOn();

    return this.networkingService.deleteRequest(API.quizAnswerDelete(quizAnswerId))
      .pipe(
        map(() => {
        }),
        catchError((error) => {
          console.error('Failed to delete quiz answer:', error);
          return throwError(() => new Error('Failed to delete quiz answer'));
        }),
        finalize(() => {
          this.sharedDataService.toggleProgressBarOff();
        })
      );
  }
}
